export default {
      id: "logo_1-usage",
      viewBox: "0 0 166 72",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#logo_1",
      toString: function () {
        return this.url;
      }
    }